import { styled } from '@mui/material';

export const RadarTargetStyled = styled('rect')(({ theme }) => ({
  cursor: 'pointer',
  [theme.breakpoints.down('xl')]: {},
}));
